import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'babel-polyfill'

import '@/style/common.css'

// 引用一些常用的JavaScript function
import Functions from './util/functions'
Vue.prototype.$util = Functions;

// 按需引入组件
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// http请求二次封装，处理token
import Http from './util/http'
Vue.prototype.$http = Http;

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
